import React from "react";
import { motion } from "framer-motion";
import { useContent, resolveAsset } from "@/context/ContentContext";
import RichText from "@/components/RichText";

const ease = [0.16, 1, 0.3, 1];

export default function About() {
  const { content } = useContent() || {};
  const a = content?.about || {};
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-40 max-w-[1500px] mx-auto px-6 md:px-12"
    >
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1, ease }}
        className="overline mb-10"
      >
        <span className="accent-bar" />
        {a.kicker || "01 — Origin"}
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 1.1, ease, delay: 0.1 }}
          className="md:col-span-7"
        >
          <h2
            className="font-display font-light leading-[0.95] tracking-[-0.03em]"
            style={{ fontSize: "clamp(2.4rem, 6vw, 5.5rem)" }}
          >
            {a.headline_a || "A result-oriented enthusiast,"}
            <br />
            <span className="italic text-[#a3a3a3]">
              {a.headline_b || "learning relentlessly."}
            </span>
          </h2>

          <div className="mt-12 dotted-line" />

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-10">
            <div>
              <span className="overline">{a.discipline_label || "Discipline"}</span>
              <p className="mt-3 font-display text-2xl">{a.discipline_title || "Chemical Engineer"}</p>
              <RichText
                as="p"
                className="text-[#a3a3a3] text-sm leading-relaxed mt-2"
                value={a.discipline_body || "Bachelor's degree, 2016."}
              />
            </div>
            <div>
              <span className="overline">{a.stagecraft_label || "Stagecraft"}</span>
              <p className="mt-3 font-display text-2xl">{a.stagecraft_title || "TV Writer · Artist"}</p>
              <RichText
                as="p"
                className="text-[#a3a3a3] text-sm leading-relaxed mt-2"
                value={a.stagecraft_body || "Aspiring screenwriter & on-screen performer."}
              />
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 1.1, ease, delay: 0.25 }}
          className="md:col-span-4 md:col-start-9 md:sticky md:top-28"
        >
          <div className="img-frame aspect-[3/4]">
            <img src={resolveAsset(a.image || "/assets/p-dreamy.jpg")} alt={a.image_caption || "Editorial portrait"} />
          </div>
          <p className="mt-4 overline">{a.image_caption || "Plate 01 · The Arrival"}</p>
        </motion.div>
      </div>
    </section>
  );
}
